import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const previewStatusManager = {
  previewStatus(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default previewStatusManager;
